import {
  FETCH_CUSTOM_REPORTS_LIST_ADMIN,
  FETCH_CUSTOM_REPORTS_LIST_ADMIN_SUCCESS,
  FETCH_CUSTOM_REPORTS_LIST_ADMIN_FAILURE,
  FETCH_CUSTOM_REPORTS_PARAMS_ADMIN,
  FETCH_CUSTOM_REPORTS_PARAMS_ADMIN_SUCCESS,
  FETCH_CUSTOM_REPORTS_PARAMS_ADMIN_FAILURE,
  RESET_CUSTOM_REPORTS_PARAMS_ADMIN,
  RESET_CUSTOM_REPORT_TO_EDIT_ADMIN,
  HIDE_CUSTOM_REPORT_FORM_ADMIN,
  UPDATE_DISPLAY_FLAG_ADMIN,
  UPDATE_DISPLAY_FLAG_ADMIN_SUCCESS,
  UPDATE_DISPLAY_FLAG_ADMIN_FAILURE,
  SAVE_CUSTOM_REPORT_ADMIN,
  SAVE_CUSTOM_REPORT_ADMIN_SUCCESS,
  SAVE_CUSTOM_REPORT_ADMIN_FAILURE,
  SHOW_CUSTOM_REPORT_FORM_FOR_ADD_ADMIN,
  SHOW_CUSTOM_REPORT_FORM_FOR_EDIT_ADMIN,
  SELECT_CUSTOM_REPORT_ADMIN,
  DELETE_CUSTOM_REPORT_ADMIN,
  DELETE_CUSTOM_REPORT_ADMIN_SUCCESS,
  DELETE_CUSTOM_REPORT_ADMIN_FAILURE,
  DISABLE_READ_ONLY_MODE_IN_CUSTOM_REPORTS_ADMIN,
  TEST_CUSTOM_REPORT_ADMIN,
  TEST_CUSTOM_REPORT_ADMIN_SUCCESS,
  TEST_CUSTOM_REPORT_ADMIN_FAILURE,
  UPDATE_ROW_ID_TO_SCROLL_ADMIN,
  RESET_ROW_ID_TO_SCROLL_ADMIN,
  CLOSE_CUSTOM_REPORT_PREVIEW_ADMIN,
  VERIFY_PARAM_TO_EDIT_ADMIN_SUCCESS,
  VERIFY_PARAM_TO_EDIT_ADMIN,
  VERIFY_PARAM_TO_EDIT_ADMIN_FAILURE,
} from './types';

import {
  fetchCustomReports as fetchCustomReportsApi,
  updateDisplayFlag as updateDisplayFlagApi,
  addCustomReport as addCustomReportApi,
  updateCustomReport as updateCustomReportApi,
  deleteCustomReport as deleteCustomReportApi,
} from '../../../shared/customReports/api';

import { fetchingError } from '../../../shared/store/actions';
import { errorNotification, successNotification } from '../../../shared/store/notificationActions';

import {
  fetchCustomReportsFactory,
  fetchCustomReportParamsFactory,
  selectCustomReportFactory,
  runCustomReportFactory,
} from '../../../shared/customReports/store/actions';

import getModalActions from '../../../shared/modals/getModalActions';
import ModalNames from '../../../shared/customReports/modalNames';

export const fetchCustomReports = fetchCustomReportsFactory({
  fetchApi: fetchCustomReportsApi,
  action: FETCH_CUSTOM_REPORTS_LIST_ADMIN,
  actionSuccess: FETCH_CUSTOM_REPORTS_LIST_ADMIN_SUCCESS,
  actionFailure: FETCH_CUSTOM_REPORTS_LIST_ADMIN_FAILURE,
});

export const fetchCustomReportParams = fetchCustomReportParamsFactory({
  action: FETCH_CUSTOM_REPORTS_PARAMS_ADMIN,
  actionSuccess: FETCH_CUSTOM_REPORTS_PARAMS_ADMIN_SUCCESS,
  actionFailure: FETCH_CUSTOM_REPORTS_PARAMS_ADMIN_FAILURE,
});

export const resetCustomReportParams = () => ({
  type: RESET_CUSTOM_REPORTS_PARAMS_ADMIN,
});

export const resetCustomReportToEdit = () => ({
  type: RESET_CUSTOM_REPORT_TO_EDIT_ADMIN,
});

export const hideCustomReportForm = () => ({
  type: HIDE_CUSTOM_REPORT_FORM_ADMIN,
});

export const {
  showAction: showCustomReportModalForDelete,
  hideAction: hideCustomReportModalForDelete,
} = getModalActions(ModalNames.CustomReportDelete);

export const {
  showAction: showCustomReportModalForParam,
  hideAction: hideCustomReportModalForParam,
} = getModalActions(ModalNames.CustomReportParam);

export const {
  showAction: showExportCustomReportInsertQueryModal,
  hideAction: hideExportCustomReportInsertQueryModal,
} = getModalActions(ModalNames.ExportCustomReportInsertQuery);

export const updateDisplayFlag = ({
  reportSetId,
  reportSetDisplayFlag,
}) => async dispatch => {
  dispatch({
    type: UPDATE_DISPLAY_FLAG_ADMIN,
  });

  try {
    await updateDisplayFlagApi({
      reportSetId,
      reportSetDisplayFlag,
    });
    dispatch({
      type: UPDATE_DISPLAY_FLAG_ADMIN_SUCCESS,
      reportSetId,
      reportSetDisplayFlag,
    });
  } catch (error) {
    dispatch(errorNotification(error.message));
    dispatch({
      type: UPDATE_DISPLAY_FLAG_ADMIN_FAILURE,
    });
  }
};

export const saveCustomReport = ({
  data: customReportData,
  isEditMode,
}, callback) => async dispatch => {
  const request = {
    reportSetId: customReportData.id,
    reportSetName: customReportData.name,
    reportCustomFlag: customReportData.customFlag,
    sql: customReportData.sql,
    serverSide: customReportData.serverSide,
    defaultOrderBy: customReportData.defaultOrderBy,
    queryParams: customReportData.queryParams,
    params: customReportData.params,
    customReportType: customReportData.customReportType,
    reports: customReportData.reports,
  };

  dispatch({
    type: SAVE_CUSTOM_REPORT_ADMIN,
  });

  try {
    if (!isEditMode) {
      const addedReport = await addCustomReportApi(request);
      dispatch(hideCustomReportForm());
      dispatch(resetCustomReportParams());
      dispatch({
        type: SAVE_CUSTOM_REPORT_ADMIN_SUCCESS,
        addedReportId: addedReport.reportSetId,
      });
    } else {
      await updateCustomReportApi(request);
      dispatch({
        type: SAVE_CUSTOM_REPORT_ADMIN_SUCCESS,
      });
    }

    if (!isEditMode) {
      dispatch(successNotification('Custom Report added'));
    } else {
      dispatch(successNotification('Custom Report updated'));
    }

    if (callback) {
      callback();
    }

    return await dispatch(fetchCustomReports());
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      dispatch({
        type: SAVE_CUSTOM_REPORT_ADMIN_FAILURE,
      });
      return;
    }
    throw error;
  }
};

export const showCustomReportFormForAdd = isAddingReportSet => dispatch => {
  dispatch(hideCustomReportForm());
  return dispatch({
    type: SHOW_CUSTOM_REPORT_FORM_FOR_ADD_ADMIN,
    isAddingReportSet,
  });
};

export const showCustomReportFormForEdit = (customReportToEditId, readOnly = false) => dispatch => {
  dispatch(hideCustomReportForm());
  dispatch(resetCustomReportToEdit());
  return dispatch({
    type: SHOW_CUSTOM_REPORT_FORM_FOR_EDIT_ADMIN,
    customReportToEditId,
    readOnly,
  });
};

export const selectCustomReport = selectCustomReportFactory({ action: SELECT_CUSTOM_REPORT_ADMIN });

export const deleteCustomReport = customReport => async dispatch => {
  dispatch({
    type: DELETE_CUSTOM_REPORT_ADMIN,
  });

  try {
    await deleteCustomReportApi(customReport.id);
    dispatch({
      type: DELETE_CUSTOM_REPORT_ADMIN_SUCCESS,
    });
    dispatch(successNotification('Custom Report removed'));
    dispatch(hideCustomReportForm());
    dispatch(fetchCustomReports());
    dispatch(resetCustomReportParams());
    dispatch(hideCustomReportModalForDelete());
    return dispatch(selectCustomReport(null));
  } catch (error) {
    dispatch({
      type: DELETE_CUSTOM_REPORT_ADMIN_FAILURE,
    });
    dispatch(errorNotification(error.message));
  }
};

export const disableReadOnlyMode = () => ({
  type: DISABLE_READ_ONLY_MODE_IN_CUSTOM_REPORTS_ADMIN,
});

export const testCustomReport = runCustomReportFactory({
  action: TEST_CUSTOM_REPORT_ADMIN,
  actionSuccess: TEST_CUSTOM_REPORT_ADMIN_SUCCESS,
  actionFailure: TEST_CUSTOM_REPORT_ADMIN_FAILURE,
});

export const updateRowToScrollTo = customReportId => ({
  type: UPDATE_ROW_ID_TO_SCROLL_ADMIN,
  customReportId,
});

export const resetRowToScrollTo = () => ({
  type: RESET_ROW_ID_TO_SCROLL_ADMIN,
});

export const closeCustomReportPreview = () => ({
  type: CLOSE_CUSTOM_REPORT_PREVIEW_ADMIN,
});

export const {
  showAction: showCustomReportModalForEdit,
  hideAction: hideCustomReportModalForEdit,
} = getModalActions(ModalNames.CustomReportEdit);


export const verifyParamOptionsQuery = runCustomReportFactory({
  action: VERIFY_PARAM_TO_EDIT_ADMIN,
  actionSuccess: VERIFY_PARAM_TO_EDIT_ADMIN_SUCCESS,
  actionFailure: VERIFY_PARAM_TO_EDIT_ADMIN_FAILURE,
  responseTransform: response => {
    if (response.columns && response.columns.includes('validationResult')) {
      return response.rows;
    } else if (response.columns) {
      return response.columns.map(column => ({
        value: column,
        label: column,
      }));
    } else {
      return response;
    }
  },
  successNotificationText: 'Query verification successful',
});

export const {
  showAction: showTestCustomReportQueryParamModal,
  hideAction: hideTestCustomReportQueryParamModal,
} = getModalActions(ModalNames.CustomReportTestQueryParam);
